module.exports = __webpack_public_path__ + "static/media/Rubik-Light.439e5f8d.woff";